
import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { activityService } from '@/services/ActivityService';
import { calculateTotalXP } from '@/utils/xpUtils';
import { useAuth } from '@/contexts/AuthContext';

export const useTotalXP = () => {
  const { user } = useAuth();
  const [totalXP, setTotalXP] = useState<number>(0);
  
  const { data: activityLogs = [], isLoading } = useQuery({
    queryKey: ['activities', user?.id],
    queryFn: () => user ? activityService.getUserActivities(user.id) : Promise.resolve([]),
    enabled: !!user?.id,
  });
  
  // Calculate and set the total XP whenever activity logs change
  useEffect(() => {
    if (activityLogs && activityLogs.length > 0) {
      const calculatedXP = calculateTotalXP(activityLogs);
      setTotalXP(calculatedXP);
      
      // If we have user profile, also update the XP there
      if (user?.id) {
        // Update profile XP if it's different from calculated XP
        if (user.profile && user.profile.xp !== calculatedXP) {
          import('@/services').then(({ profileService }) => {
            profileService.updateUserProfile(user.id, { xp: calculatedXP });
          });
        }
      }
    }
  }, [activityLogs, user]);
  
  return { totalXP, isLoading };
};
